import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "calendarParser",
})
export class CalendarParserPipe implements PipeTransform {
  transform(value: Date): Date {
    return new Date(
      Date.UTC(value.getFullYear(), value.getMonth(), value.getDate(), 0, 0, 0)
    );
  }
}
